import { render, staticRenderFns } from "./UsageConditionsContent.vue?vue&type=template&id=54d83e62&scoped=true"
import script from "./UsageConditionsContent.vue?vue&type=script&lang=js"
export * from "./UsageConditionsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d83e62",
  null
  
)

export default component.exports